/**
 * Converted from flindersonline-frontend component
 * GSAP and Swiper are available as global variables
 * Original imports have been removed and replaced with global access
 */

// Flinders Online Brag Points USP with Scroll/Draggable Feature
// gsap is available globally
// ScrollTrigger is available globally via gsap
(function() {
	"use strict";
	
	document.addEventListener('DOMContentLoaded', function() {

    let mode = false;
    const bragpointScrollerTriggers = [];
    let isMobile = getViewportType() === 'mobile';

	  const components = document.querySelectorAll('.cmp-flindersonline-bragpoints');   
    // ScrollTrigger is now registered globally in scrolltrigger-config.js

    document.querySelector('.scroll-top')?.addEventListener('click', (e) => {
      e.preventDefault();      
      // Temporarily disable GSAP ScrollTriggers
      bragpointScrollerTriggers.forEach(trigger => trigger.disable());
      
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    
      // Re-enable ScrollTriggers after scroll completes
      setTimeout(() => {
        bragpointScrollerTriggers.forEach(trigger => trigger.enable());
        ScrollTrigger.refresh();
      }, 1000); 
    });    

    // Check screensize
    function getViewportType() {
      const screenWidth = Math.max(
        window.screen.width,
        window.innerWidth || document.documentElement.clientWidth
      );
      return screenWidth < 768 ? 'mobile' : (screenWidth < 1024 ? 'tablet' : 'desktop');
    }  

    // Check for AEM's authoring classes 
    function isEditOrDesignMode() {
      const params = new URLSearchParams(window.location.search);
      const wcmmode = params.get('wcmmode');
      const isEditorPath = window.location.pathname.includes('/editor.html');
      
      if (wcmmode === 'disabled') {
        return null;
      }
      if (wcmmode === 'edit' || wcmmode === 'design' || isEditorPath) {
        return 'AUTHOR';
      }
      return 'PUBLISH';
    }

    //Check if Hero-Banner is present in the page
    function checkForParallax() {
      const hero = document.querySelector('.hero-banner');
      if (!hero) return;
      const parallax = hero.querySelector('.end-element');
      mode = parallax ? true : false;
    }

    checkForParallax();
   
    function initBragPoints(){
      if (components.length > 0) {  
        components.forEach(component => {

          const trophies = gsap.utils.toArray(".trophy", component);
          const overlays = gsap.utils.toArray(".trophy .overlay", component);
          const scaleRange = { min: 0.6, max: 1.0 };
          const opacityRange = { min: 0, max: 0.3 };
          const saturationRange = { min: 0.1, max: 0.4 };
          const yOffset = -80; 
          const trophyContainer = component.querySelector('.trophy-container');

          // Adjust Start Point if Header is Sticky
          const header = document.querySelector('.main_header_container');
          const isSticky = window.getComputedStyle(header).position === 'sticky';
          const headerOffset = header && isSticky ? ((header.offsetHeight / window.innerHeight) * 100) : 0;
          const startPoint = 75; 

          const isAuthor = component.dataset.author === 'true'; 

          trophies.forEach((trophy, index) => {
            const isLast = index === trophies.length - 1;
            const scale = trophies.length === 1 
              ? scaleRange.max 
              : scaleRange.min + (scaleRange.max - scaleRange.min) * (index / (trophies.length - 1));
            const y = index * yOffset;
            const yAdjustment = isMobile ? 80 : 50;
            const power = trophies.length;
            const opacity = opacityRange.max - (opacityRange.max * Math.pow(index/(trophies.length-1), power));

            const normalizedScale = (scale - scaleRange.min) / (scaleRange.max - scaleRange.min);
            const brightness = Math.min(1.5, 1 + (0.5 * (1 - normalizedScale))); 
            const saturation = saturationRange.max - ((saturationRange.max - saturationRange.min) * normalizedScale)

            // Filter animation sequence
            const filterSequence = {
                inactive: "brightness(" + brightness + ") saturate(" + saturation + ")",
                active: "brightness(1) saturate(1)",
            };

            gsap.set(trophy, {
              opacity: 0,
              y: y + yAdjustment,
              scale: scaleRange.min, 
              zIndex: 0,
              transformOrigin: "bottom center",
            });

            const tl = gsap.timeline({
                  defaults: { 
                      ease: "power2.out" // Consistent easing for all animations
                  },
                  onUpdate: function() {
                    let highestScale = 0;
                    let highestScaleTrophy = null;
                    
                    trophies.forEach(t => {
                      const currentScale = gsap.getProperty(t, "scale");
                      if (currentScale > highestScale) {
                        highestScale = currentScale;
                        highestScaleTrophy = t;
                      }
                    });
                    
                    // Only update saturation if this trophy is NOT the highest scaled one
                    if (trophy !== highestScaleTrophy) {
                      const currentScale = gsap.getProperty(trophy, "scale");
                      const currentNormalizedScale = (currentScale - scaleRange.min) / (scaleRange.max - scaleRange.min);
                      const newSaturation = saturationRange.min + ((saturationRange.max - saturationRange.min) * currentNormalizedScale);
                      const currentBrightness = Math.min(1.5, 1 + (0.5 * (1 - currentNormalizedScale)));
                      
                      gsap.set(trophy, {
                        filter: "brightness(" + currentBrightness + ") saturate(" + newSaturation + ")"
                      });
                    }

                    if (trophy === highestScaleTrophy) {
                      gsap.set(trophy, {
                        opacity: 1,
                        zIndex: trophies.length * 2
                      });
                    }
                  }
              });

			      if(!isAuthor){
              ScrollTrigger.create({
                animation: tl,
                trigger: trophyContainer,
                start:  `top ${startPoint + headerOffset}%`, 
                end: `bottom 50%`,
                scrub: 2,
                fastScrollEnd: true, // Better handling of quick scrolls
              });
            }

            gsap.set(overlays[index],{
              opacity: 1,
            });

            tl.set(trophy, {
              opacity: 0,
              y: y + yAdjustment,
              scale: scaleRange.min, 
              zIndex: 0,
              filter: filterSequence.inactive,
              transformOrigin: "bottom center",
            })

            // 1. Fade in and move to position (scale stays 1)
            .to(trophy, {
                opacity: 1,
                y: y,
                scale: 1,
                duration: 0.3,
                filter: filterSequence.active,
                zIndex: trophies.length * 2
            }, index * 0.2)
            
            // 2. Only then scale down on scroll-up
            .to(trophy, {
                scale: scale, 
                duration: 0.6,
                zIndex: 0, 
                filter: isLast ? filterSequence.active : filterSequence.inactive,
            }, index * 0.2 + 0.2);
            
            tl.to(overlays[index], {
               opacity: 0, 
               duration: 0.3
            }, index * 0.2) 

            .to(overlays[index], {
              opacity: opacity, 
              duration: 0.6,
            }, index * 0.2 + 0.2); 
            
            bragpointScrollerTriggers.push(tl.scrollTrigger);
          });

          trophyContainer.style.height = trophies.reduce((sum, t) => sum + Math.max(0, t.offsetHeight - (trophies.length * 5)), 0) + 'px';
        });
      }
    }

    initBragPoints();

    function refreshBragpointScrollTriggers() {
      // Kill only this component's triggers
      bragpointScrollerTriggers.forEach(trigger => trigger?.kill());
      bragpointScrollerTriggers.length = 0; // Clear array
      
      // Recreate animations
      initBragPoints();
      ScrollTrigger.refresh();
    }
    
    let resizeTimeout;
    function handleResize() {
      clearTimeout(resizeTimeout);
      isMobile = getViewportType() === 'mobile';
      resizeTimeout = setTimeout(() => {
        refreshBragpointScrollTriggers();
      }, 250); 
    }
  
    // Handle resize
    window.addEventListener('resize', handleResize);
	});
})();